document.addEventListener( 'DOMContentLoaded', function () {
  var main = new Splide( '#main-slider', {
    type      : 'fade',
    rewind    : true,
    pagination: false,
    arrows    : false,
  } );

  var thumbnails = new Splide( '#thumbnail-slider', {
    fixedWidth  : 128,
    fixedHeight : 128,
    gap         : 12,
    rewind      : true,
    pagination  : false,
    arrows      : true,
    arrowPath: 'M 1.816406 21.816406 L 33.792969 21.816406 L 27.804688 27.804688 C 27.09375 28.515625 27.09375 29.667969 27.804688 30.375 C 28.160156 30.730469 28.625 30.910156 29.089844 30.910156 C 29.554688 30.910156 30.023438 30.730469 30.375 30.375 L 39.46875 21.285156 C 40.175781 20.574219 40.175781 19.425781 39.46875 18.714844 L 30.375 9.625 C 29.667969 8.914062 28.515625 8.914062 27.804688 9.625 C 27.09375 10.332031 27.09375 11.484375 27.804688 12.195312 L 33.792969 18.183594 L 1.816406 18.183594 C 0.8125 18.183594 0 18.996094 0 20 C 0 21.003906 0.8125 21.816406 1.816406 21.816406 Z M 1.816406 21.816406',
    cover       : true,
    isNavigation: true,
    breakpoints : {
      768: {
            arrows: false,
          },
      600: {
        fixedWidth : 75,
        fixedHeight: 75,
      },
    },
  } );

  main.sync( thumbnails );
  main.mount();
  thumbnails.mount();
} );